import axios from "axios";
import { BASEURL } from "./baseUrl";
import axiosInstance from "./axiosInstance";

// Create axios instance if you already have one, use that instead
const API = axios.create({
  baseURL: BASEURL,
});

// Attach JWT automatically (if not already handled globally)
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("access");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ================================
// GET ALL CRON TASKS
// ================================
export const getCronTasks = () =>
  API.get("/cron-manager/");

// ================================
// TOGGLE TASK ACTIVE
// ================================
export const toggleCronTask = (id) =>
  API.post(`/cron-manager/${id}/toggle/`);

// ================================
// RUN TASK NOW
// ================================
export const runCronNow = (id,data) => {

  return axiosInstance.post(
    `/cron-manager/${id}/run-now/`,
    data
  );

};